<p *ngIf="showDowntimeBanner" class="top-banner">
    <tra-md slug="{{getBannerMsg()}}"></tra-md>
</p>